import { enumeration } from '@dazn/peng-html5-tools-utils';
var RequestedAssetType = enumeration([
    'AUDIO_INIT_SEGMENT',
    'AUDIO_SEGMENT',
    'AUDIO_VARIANT_MANIFEST',
    'LICENSE',
    'MASTER_MANIFEST',
    'VIDEO_INIT_SEGMENT',
    'VIDEO_SEGMENT',
    'VIDEO_VARIANT_MANIFEST',
]);
export { RequestedAssetType };
//# sourceMappingURL=RequestedAssetType.js.map